





































import { Component,	Vue, Watch } from 'vue-property-decorator'

import { bus } from '@/main'
import GlobalMixins from '@/mixins'
import { Languages } from '@/enums'

import InfoButton from '@/components/InfoButton.vue'

@Component({
	components: {
		InfoButton
	}
})
export default class SelectPunishment extends GlobalMixins {
	punishments: { [key: number]: { name: string, value: string, requiresDate?: boolean } } = this.$store.getters.punishments
	selectedPunishment: string | false = false

	@Watch('selectedPunishment')
	onSelectedPunishmentChange(): void {
		if (this.selectedPunishment) {
			this.$store.dispatch('setSelectedPunishment', this.selectedPunishment)

			bus.$emit('setNextButton', 'next')
		} else {
			bus.$emit('setNextButton', false)
		}
	}

	mounted() {
		bus.$emit('setNextButton', false)

		bus.$on('goToNextScreen', () => {
			let selectedPunishmentTitle = ''

			this.$store.getters.punishments.forEach((punishment: any) => {
				if (punishment.value === this.selectedPunishment) selectedPunishmentTitle = punishment.name
			})

			if(selectedPunishmentTitle) {
				_paq.push(['trackEvent', 'keuzeStraf', selectedPunishmentTitle])
			}

			let punishmentRequiresDate: boolean = false

			;[...(<any>this.punishments)].forEach((punishment: { name: string, value: string, requiresDate?: boolean }) => {
				if (this.selectedPunishment === punishment.value) {
					if (punishment.requiresDate) {
						punishmentRequiresDate = true
					}
				}
			})

			if (punishmentRequiresDate) {
				this.$store.dispatch('setCrimeWhen', 'skipped')

				Vue.nextTick(() => {
					this.$router.push({ name: this.language === Languages.NL ? 'punishment-when' : 'punishment-when-'+this.language })
				})
			} else {
				this.$store.dispatch('setPunishmentWhen', 'skipped')
				this.$store.dispatch('setPunishmentLength', 'skipped')

				Vue.nextTick(() => {
					this.$router.push({ name: this.language === Languages.NL ? 'crime-when' : 'crime-when-'+this.language })
				})
			}
		})

		if (this.$store.getters.user.selectedPunishment) {
			this.selectedPunishment = this.$store.getters.user.selectedPunishment
		}
	}

	beforeDestroy() {
		bus.$off('goToNextScreen')
	}

	focus(index: number) {
		if(this.punishments[index]) {
			const punishmentEl = document.querySelector("#punishment-"+index)
			if(punishmentEl) {
				(punishmentEl as HTMLElement).focus();
				(punishmentEl as HTMLElement).click();
			}
		}
	}
}
